/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Externally hosted YouTube video.
 */
export type PropertyExternalMediaYoutubeVideoInput = {
    /**
     * Video media kind.
     */
    kind: PropertyExternalMediaYoutubeVideoInput.kind;
    /**
     * YouTube hosting provider.
     */
    provider: PropertyExternalMediaYoutubeVideoInput.provider;
    /**
     * Public HTTP(S) URL for the hosted media.
     */
    url: string;
};
export namespace PropertyExternalMediaYoutubeVideoInput {
    /**
     * Video media kind.
     */
    export enum kind {
        VIDEO = 'VIDEO',
    }
    /**
     * YouTube hosting provider.
     */
    export enum provider {
        YOUTUBE = 'YOUTUBE',
    }
}

